export interface AuthSession {
    token: string;
    role: string;
    regions: string[];
    label: string;
    apiBaseUrl?: string;
}
const normalizedApi = (api: string) => api.replace(/\/$/, '');
const sessionKey = (api: string) => `acq_auth_by_api:${normalizedApi(api)}`;
function isLocal(api: string) {
    try { return ['127.0.0.1', 'localhost', '[::1]'].includes(new URL(api).hostname); } catch { return false; }
}
export function readAuthSession(api: string): AuthSession | null {
    try {
        const scoped = localStorage.getItem(sessionKey(api));
        const auth = JSON.parse(scoped || localStorage.getItem('acq_auth') || 'null');
        if (!auth || typeof auth.token !== 'string' || typeof auth.role !== 'string' || !Array.isArray(auth.regions)) return null;
        if (auth.apiBaseUrl && normalizedApi(auth.apiBaseUrl) !== normalizedApi(api)) return null;
        // Legacy sessions belonged to the previous remote service. Never send
        // that token to a newly activated local API to see whether it works.
        if (!scoped && !auth.apiBaseUrl && isLocal(api)) return null;
        return auth;
    } catch { return null; }
}
export function saveAuthSession(auth: AuthSession, api: string): void {
    const value = JSON.stringify({ ...auth, apiBaseUrl: normalizedApi(api) });
    localStorage.setItem(sessionKey(api), value);
    localStorage.setItem('acq_auth', value);
}
export function clearAuthSession(api: string): void {
    localStorage.removeItem(sessionKey(api));
    try {
        const legacy = JSON.parse(localStorage.getItem('acq_auth') || 'null');
        if (legacy && ((!legacy.apiBaseUrl && !isLocal(api)) || normalizedApi(legacy.apiBaseUrl || '') === normalizedApi(api))) localStorage.removeItem('acq_auth');
    } catch { localStorage.removeItem('acq_auth'); }
}
